import SuppliersReportProduct from './SuppliersReportProductModal';

export default SuppliersReportProduct;
